import LlamadaService from './llamada_service.js';
import ConfigService from './config_service.js';
import LoginService from './login_service.js';

const llamada = new LlamadaService();
const configService = new ConfigService();
const config = configService.getConfig();
const loginService = new LoginService();
export default class CirugiaService {
	get(data) {
		data.action = 'get';
		const token = loginService.getToken();
		return llamada.sendPost(config.baseUrl + 'CirugiaWebService.php?token='+token, data);
	}

	save(data) {
		data.action = 'save';
		const token = loginService.getToken();
		return llamada.sendPost(config.baseUrl + 'CirugiaWebService.php?token='+token, data);
	}

	remove(data) {
		data.action = 'remove';
		const token = loginService.getToken();
		return llamada.sendPost(config.baseUrl + 'CirugiaWebService.php?token='+token, data);
	}

	getComplicacionesCirugia(data) {
		data.action = 'get-complicaciones-cirugia';
		const token = loginService.getToken();
		return llamada.sendPost(config.baseUrl + 'CirugiaWebService.php?token='+token, data);
	}

	getProcedimientosCirugia(data) {
		data.action = 'get-procedimientos-cirugia';
		const token = loginService.getToken();
		return llamada.sendPost(config.baseUrl + 'CirugiaWebService.php?token='+token, data);
	}
}

